import { api } from "../../api/apiSlice";

// Self-service "my account" calls - the caller's own row only, so no
// permission beyond being signed in (the API's UsersMeController is plain
// [Authorize]). Deliberately separate from usersApi.js, whose endpoints are
// all Admin.ManageUsers.
export const profileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // PUT /users/me/password - checks the current password, needs 6+
    // characters, and clears MustChangePassword. Live on remote since before
    // this screen existed; the Flutter app has used it all along.
    changeMyPassword: builder.mutation({
      query: ({ currentPassword, newPassword }) => ({
        url: "/users/me/password",
        method: "PUT",
        data: { currentPassword, newPassword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useChangeMyPasswordMutation } = profileApi;
